export default "__VITE_ASSET__D3kPSBAP__"